import { render, staticRenderFns, recyclableRender, components } from "./order-details.vue?vue&type=template&id=b2ddbeb0&scoped=true&"
var renderjs
import script from "./order-details.vue?vue&type=script&lang=js&"
export * from "./order-details.vue?vue&type=script&lang=js&"
import style0 from "./order-details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order-details.vue?vue&type=style&index=1&id=b2ddbeb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ddbeb0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/order-details/order-details.vue"
export default component.exports